/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
$(document).bind("contextmenu",function(e){
  return false;
    });
$(window).scroll(function(){
    if ($(this).scrollTop() > 50) {
       $('#section-header').addClass('stickey-header');
      
    } else {
       $('#section-header').removeClass('stickey-header');
    }
});

$(document).ready(function() {
    $('#notify-me').click(function(e) {
      e.preventDefault();
      $('#notify-me-wrapper').fadeIn('slow');
    });
  });

$(document).ready(function() {
   // const anchors = [...document.querySelectorAll("a")];
   //  anchors.forEach(anchor => {
   //    let link = anchor.getAttribute("href");
   //    if(link && link != "" && link != "/search" && link != "/pages/halloween-sale" && (link.includes("https") || link[0] == "/")) {
   //      anchor.setAttribute("target", "_blank")
   //    }
   //  })
  $('.ColorSwatch__Radio').change(function (e) {
    const x = e.target.closest(".ProductItem__Info");
    if(e.target.value == "Carbon Black") {
      $(x).find(".offPercentage").addClass("show");
    }
    else {
      $(x).find(".offPercentage").removeClass("show");
    }
    ;
  })
});

$(function(){
  $('.easyzoom').easyZoom();
});

$('.download__button').click(function () {
    const button = $(this);
    $(button).addClass("button--loading");
    window.setTimeout(function () {
      $(button).removeClass("button--loading");
    }, 2000);
});

function calculateb2bFinalPrice (price) {
  const price_text = $('#b2b_final_total_price').text();
  const price_array = price_text.split(" ");
  // const current_price = parseFloat(price_array[0].slice(1));
  // const final_price = price + current_price;
  // $('#b2b_final_total_price').text(price_array[0][0] + final_price + " " + (price_array[1] ?? "") )

  let final_price = 0;
  $('.b2b_item_price .money').each(function() {
    const price_text = $(this).text();
    const price_array = price_text.split(" ");
    const current_price = parseFloat(price_array[0].slice(1));
    final_price = final_price + current_price;
    
  })
  $('#b2b_final_total_price').text(price_array[0][0] + final_price + " " + (price_array[1] ?? "") )
  let discountMultiplier = 0.8;
  const discountEl = document.getElementById('discount-reader');
  if (discountEl) {
    const couponPercentage = parseFloat(discountEl.dataset.couponPercentage);
    discountMultiplier = (100 - couponPercentage) / 100;
  }
  $('#b2b_final_discount_total_price').text(price_array[0][0] + ((final_price * discountMultiplier).toFixed(2)) + " " + (price_array[1] ?? "") )
}

function calculateb2bSubtotalPrice (element, quantity) {
  const price_text = $(element).find('.b2b_price .money').text();
  const price = parseFloat(price_text.split(" ")[0].slice(1));
  // const price = parseFloat($(element).find('.b2b_price').attr('amount'));
  // const quantity = parseInt($(element).find('.b2b_quantity').val())
  const total = price * quantity;
  const money_text = $(element).find('.b2b_item_price .money').text();
  const money_array = money_text.split(" ");
  const money_subtotal = money_array[0][0] + total + " " + (money_array[1] ?? "");
  $(element).find('.b2b_item_price .money').text(money_subtotal);
  calculateb2bFinalPrice(total)
}

$('.b2b_quantity_minus').click(function (e) {
  e.preventDefault();
  const quantiy = $(this).siblings('.b2b_quantity');
  const value = parseInt($(quantiy).val())
  const finalVal = value <=1 ? 0 : value - 1;
  $(quantiy).val(finalVal)
  calculateb2bSubtotalPrice($(this).parents(".b2b_item"), finalVal);
  if(finalVal == 0) {
    $(this).parents(".b2b_item").removeClass("b2b_item_added");
  }
})

$('.b2b_quantity_plus').click(function (e) {
  e.preventDefault();
  const quantiy = $(this).siblings('.b2b_quantity');
  const value = parseInt($(quantiy).val())
  const finalVal = value + 1;
  $(quantiy).val(finalVal)
  calculateb2bSubtotalPrice($(this).parents(".b2b_item"), finalVal);
  $(this).parents(".b2b_item").addClass("b2b_item_added")
})

async function createCheckout() {
  const elements = $(".b2b_item_added");
  // let items = [];
  await fetch(window.Shopify.routes.root + 'cart/clear.js', {
    method: 'POST'
  })
  // $(elements).each(function() {
  //   items.push({
  //     id: parseInt($(this).attr('id')),
  //     quantity: parseInt($(this).find('.b2b_quantity').val())
  //   })
  // });
  // const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
  //   method: 'POST',
  //   headers: {
  //     'Content-Type': 'application/json'
  //   },
  //   body: JSON.stringify({
  //     'items': items
  //   })
  // })
  // const data = await response.json();
  // console.log("items: ", items)
  // console.log("data: ", data)
  // return data;

  let checkoutURL = "https://mi-gei-hardware-design-studio.myshopify.com/cart/clear?return_to=/cart/add?";
  $(elements).each(function() {
    checkoutURL += `items[][id]=${$(this).attr('id')}%26items[][quantity]=${$(this).find('.b2b_quantity').val()}%26`;
  });
  const discountEl = document.getElementById('discount-reader');
  checkoutURL += `return_to=/checkout?discount=${discountEl && discountEl.dataset.couponCode ? discountEl.dataset.couponCode : 'NEO-TRADE'}`;
  console.log("checkoutURL", checkoutURL);
  return checkoutURL;
}

$("#b2b_Checkout").click(async function(e){
  e.preventDefault();
  const data = await createCheckout();
  if(data) {
    // $(this).parents('form').submit()
    window.location.href = data;
  }
})

function AddMultipleProducts (excludeProduct = false) {
    const form = document.querySelector('form[action*="/cart/add"]');
    const formData = new FormData(form);
    const selectedColor = formData.get("option-0")?.replaceAll(" ", "");
    const selectedColorValue =`variantId${selectedColor[0]?.toUpperCase() + selectedColor?.slice(1, selectedColor.length)?.toLowerCase()}`;
    const active_product_data = {
      id: formData.get('id'), // Assuming the form has an input field with name="id"
      quantity: formData.get('quantity') // Assuming the form has an input field with name="quantity"
    };
    const additional_selected_products = [...document.querySelectorAll('.associated_products .list_item[data-selection="true"]')];
    const payload = {
      items: [
        ...(excludeProduct && additional_selected_products.length > 0 ? [] : [{
          id: active_product_data.id,
          quantity: active_product_data.quantity
        }]),
        ...additional_selected_products.map(item => ({
          id: item.dataset[selectedColorValue] ?? item.dataset["variantId"],
          quantity: active_product_data.quantity
        }))
      ]
    };
    document.dispatchEvent(new CustomEvent("theme:loading:start"));
    
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })
    .then(response => {
      document.dispatchEvent(new CustomEvent("theme:loading:end"));
      return response.json();
    })
    .then(data => {
      if (data) {
        document.dispatchEvent(new CustomEvent("product:added", {
          bubbles: true,
          detail: {
            variant: "",
            quantity: 10
          }
        }));
      }
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }

// CURRENCY CHANGE DYNAMICALLY - START
// Mapping of language directories to currency data-values
const currencyMap = {
    "default": "USD", // Default directory for English US
    "en-au": "AUD",   // English Australia
    "en-ca": "CAD",   // English Canada
    "fr-ca": "CAD",   // French Canada
    "en-uk": "GBP",   // English UK
    "fr": "EUR",       // French France
    "en-ae": "AED"    //UAE
};
// Function to set the currency based on the URL directory
function setCurrency(urlDirectory, currency) {
    if (currency) {
      setTimeout(() => {
        document.querySelector(`[data-value='${currency}']`).click();
        document.querySelector(`[data-value='${currency}']`).click();
        const lang_element = document.querySelector(`[data-country-code='${(urlDirectory && Object.keys(currencyMap).includes(urlDirectory)) ? urlDirectory : 'default'}']`);
        document.querySelector('.country-lang-dropdown-toggle').innerHTML = lang_element.innerHTML;
        document.querySelector('.country-lang-dropdown').style.opacity = '1';
      }, 500)
    }
    else {
      document.querySelector('.country-lang-dropdown').style.opacity = '1';
    }
}
// Call the function when the page starts to load
window.addEventListener('DOMContentLoaded', () => {
  const urlDirectory = window.location.pathname.split('/')[1];
  const currency = currencyMap[urlDirectory] ?? currencyMap.default;
  
  // Create a MutationObserver to detect when the component is added
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === "childList") {
        // Check if .component is present in the added nodes
        mutation.addedNodes.forEach((node) => {
  
          if (node.classList && (node.classList.contains("doubly-wrapper") || node.classList.contains("doubly-float") )) {
            setCurrency(urlDirectory, currency);
            observer.disconnect(); // Stop observing if needed
          }else {
              // Also check for the desired classes within the node
              const targetElement = document.querySelector(".doubly-wrapper, .doubly-float");
              if (targetElement) {
                setCurrency(urlDirectory, currency);
                observer.disconnect(); // Stop observing if needed
              }
          }
        });
      }
    });
  });
  
  // Start observing the document for changes
  observer.observe(document.body, {
    childList: true, // Watch for direct child additions or removals
    subtree: true,   // Also watch for changes to all descendants
  });
});
// CURRENCY CHANGE DYNAMICALLY - END

//LANUAGE SELECTOR - START
const currencyLang = {
    "default": "x-default", // Default directory for English US
    "en-au": "en-AU",   // English Australia
    "en-ca": "en-CA",   // English Canada
    "fr-ca": "fr-CA",   // French Canada
    "en-uk": "en-GB",   // English UK
    "fr": "fr",       // French France
    "en-ae": "en-AE"    //UAE
};

function toggleDropdown() {
    const dropdownMenu = document.querySelector('.country-lang-dropdown-menu');
    dropdownMenu.style.display = dropdownMenu.style.display === 'block' ? 'none' : 'block';
}

function selectOption(element) {
    document.querySelector('.country-lang-dropdown-toggle').innerHTML = element.innerHTML;
    document.querySelector('.country-lang-dropdown-menu').style.display = 'none';
    const urlDirectory = element.getAttribute('data-country-code');
    const currencyLangValue = currencyLang[urlDirectory] ?? 'x-default';
    const redirect = document.querySelector(`[hreflang='${currencyLangValue}']`)?.getAttribute('href')
    if(redirect) window.location.href = redirect;
}

document.addEventListener('click', function (e) {
    const dropdown = document.querySelector('.country-lang-dropdown');
    if (!dropdown.contains(e.target)) {
        document.querySelector('.country-lang-dropdown-menu').style.display = 'none';
    }
});
//LANUAGE SELECTOR - END

document.addEventListener("DOMContentLoaded", function () {
  // Function to calculate the start date of Black Friday for a given year in UTC
  // Black Friday is the fourth Friday of November.
  function getBlackFridayUTCTimestamp(year) {
      // Start of November 1st in UTC
      const nov1 = new Date(Date.UTC(year, 10, 1)); // Month 10 is November (0-indexed)
      
      // Calculate how many days from Nov 1st to the first Friday (Friday is day 5, Sunday is 0)
      const dayOfWeekOfNov1 = nov1.getUTCDay();
      let daysUntilFirstFriday = 5 - dayOfWeekOfNov1;
      if (daysUntilFirstFriday < 0) {
          daysUntilFirstFriday += 7;
      }
      
      // Calculate the day of the month for the fourth Friday
      const fourthFridayDay = 1 + daysUntilFirstFriday + 21; // +21 days (3 weeks)
      
      // Return the UTC timestamp (milliseconds since epoch) for midnight UTC on that day
      console.log("i was called")
      return Date.UTC(year, 10, fourthFridayDay, 0, 0, 0); 
  }

  function getUTCTimestamp(year, month, day) {
    // month is 1-indexed for convenience → convert to 0-indexed
    return Date.UTC(year, month - 1, day, 8, 0, 0);
  }

  // Set the deadline to the start of Black Friday 2025 in UTC (GMT)
  // This timestamp is consistent worldwide.
  // let deadline = getBlackFridayUTCTimestamp(2025);
  let deadline = getUTCTimestamp(2025, 12, 8);
  
  // Calling defined function at certain interval
  let x = setInterval(function () {
    const countDownClock = $('.clockdiv');
    if (countDownClock.length) {
      // Getting current date and time universally in milliseconds since epoch
      // new Date().getTime() always returns UTC milliseconds regardless of client timezone.
      let now = new Date().getTime();
    
      // Calculating difference using UTC timestamps
      let t = deadline - now;
    
      // Getting values of days, hours, minutes, seconds
      let days = Math.floor(t / (1000 * 60 * 60 * 24));
      let hours = Math.floor((t % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      let minutes = Math.floor((t % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = Math.floor((t % (1000 * 60)) / 1000);
    
      // Show the output time
      $(".days").each(function() {
        $(this).html(days);
      });
      $(".hours").each(function() {
        $(this).html(hours);
      });
      $(".minutes").each(function() {
        $(this).html(minutes);
      });
      $(".seconds").each(function() {
        $(this).html(seconds);
      });
    
      // Show overtime output when the countdown ends
      if (t < 0) {
        clearInterval(x);
        $(".days").each(function() {
          $(this).html("0");
        });
        $(".hours").each(function() {
          $(this).html("0");
        });
        $(".minutes").each(function() {
          $(this).html("0");
        });
        $(".seconds").each(function() {
          $(this).html("0");
        });
      }
    }
  }, 1000);
});

document.addEventListener('variant:changed', function(event) {
    console.log("event hit");
    const tempDiv = document.querySelector(`#custom_product_description`);
    tempDiv.innerHTML = window.variantDescription?.descriptions?.[event.detail.variant.id] ? window.variantDescription?.descriptions?.[event.detail.variant.id] : window.variantDescription?.main

    const form = document.querySelector('form[action*="/cart/add"]');
    const formData = new FormData(form);
    const selectedColor = formData.get("option-0")?.replaceAll(" ", "");
    const selectedColorValue =`variantImage${selectedColor[0]?.toUpperCase() + selectedColor?.slice(1, selectedColor.length)?.toLowerCase()}`;
    console.log("selectedColorValue", selectedColorValue);
    const additional_selected_products = [...document.querySelectorAll('.associated_products .list_item')];
    additional_selected_products.forEach(item => {
      const img_url = item.dataset[selectedColorValue] ?? item.dataset["variantImage"];
      if(img_url) {
        const imgElement = item.querySelector('img:last-of-type');
        if(imgElement) {
          imgElement.setAttribute('src', img_url)
        }
      }
    })
});

// document.addEventListener("DOMContentLoaded", function () {
//   console.log("i am loaded");

//   document.querySelectorAll(".dynamic-atc").forEach(function (button) {
//     button.addEventListener("click", function () {
//       const productWrapper = button.closest(".ProductItem__Wrapper");
//       if (!productWrapper) return;

//       const imageLinkElement = productWrapper.querySelector(".ProductItem__ImageWrapper");
//       const link = imageLinkElement ? imageLinkElement.getAttribute("href") : null;

//       if (!link) {
//         console.warn("No link found in ProductItem__ImageWrapper");
//         return;
//       }

//       const formatURL = new URL(link, window.location.origin);
//       let variantId = formatURL.searchParams.get("variant");

//       if (variantId && variantId.includes("#")) {
//         variantId = variantId.split("#")[0];
//       }

//       if (!variantId) {
//         variantId = button.getAttribute("default-id");
//       }

//       document.dispatchEvent(new CustomEvent("theme:loading:start"));

//       fetch("/cart/add.js", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/x-www-form-urlencoded",
//         },
//         body: new URLSearchParams({
//           id: variantId,
//           quantity: 1,
//         }),
//       })
//         .then((response) => {
//           if (!response.ok) {
//             throw new Error("Network response was not ok");
//           }
//           return response.json();
//         })
//         .then((data) => {
//           document.dispatchEvent(new CustomEvent("theme:loading:end"));
//           document.dispatchEvent(
//             new CustomEvent("product:added", {
//               bubbles: true,
//               detail: {
//                 variant: "", // You can set `data.variant_id` here if desired
//                 quantity: 10, // Adjust based on your logic
//               },
//             })
//           );
//         })
//         .catch((error) => {
//           console.error("Error adding product to cart:", error);
//           document.dispatchEvent(new CustomEvent("theme:loading:end"));
//         });
//     });
//   });
// });

function dATC(button) {
    
      const productWrapper = button.closest(".ProductItem__Wrapper");
      if (!productWrapper) return;

      const imageLinkElement = productWrapper.querySelector(".ProductItem__ImageWrapper");
      const link = imageLinkElement ? imageLinkElement.getAttribute("href") : null;

      if (!link) {
        console.warn("No link found in ProductItem__ImageWrapper");
        return;
      }

      const formatURL = new URL(link, window.location.origin);
      let variantId = formatURL.searchParams.get("variant");

      if (variantId && variantId.includes("#")) {
        variantId = variantId.split("#")[0];
      }

      if (!variantId) {
        variantId = button.getAttribute("default-id");
      }

      document.dispatchEvent(new CustomEvent("theme:loading:start"));

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({
          id: variantId,
          quantity: 1,
        }),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json();
        })
        .then((data) => {
          document.dispatchEvent(new CustomEvent("theme:loading:end"));
          document.dispatchEvent(
            new CustomEvent("product:added", {
              bubbles: true,
              detail: {
                variant: "", // You can set `data.variant_id` here if desired
                quantity: 10, // Adjust based on your logic
              },
            })
          );
        })
        .catch((error) => {
          console.error("Error adding product to cart:", error);
          document.dispatchEvent(new CustomEvent("theme:loading:end"));
        });
    
  }

(function () {
  document.addEventListener(
    "submit",
    function (e) {
      const form = e.target;
      const honeypot = form.querySelector('input[name="hp_field"]');

      if (honeypot && honeypot.value.trim() !== "") {
        console.warn("🛑 Spam blocked by honeypot");

        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();

        return false;
      }
    },
    true
  );
})();

// document.addEventListener('product:added', function(event) {
//   // Call pinterest track function when product is added to cart
//   console.log("pinterest event for ", event )
//   pintrk('track', 'addtocart');
// });